/* eslint-disable @typescript-eslint/no-unsafe-return */

import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import type { As } from '#@/shared/constants/styledComponents';
import { COLOR } from '#@/shared/utils/styles';

import DropdownAction, { type DropdownActionProps } from '../DropdownAction';
import HoverableElement from '../HoverableElement';
import { DropdownMenuContext } from './DropdownMenuContext';

export interface ActionProps {
  danger?: boolean;
  as?: As;
  shouldCloseOnSelect?: boolean;
  tooltipText?: string | null;
}

const ActionBase: React.FC<DropdownActionProps & ActionProps> = ({
  onClick,
  danger: _,
  tooltipText,
  checkboxProps,
  radioButtonProps,
  shouldCloseOnSelect = !checkboxProps && !radioButtonProps,
  ...props
}) => {
  const { closeModal, isTriggered } = useContext(DropdownMenuContext);

  const handleClick: DropdownActionProps['onClick'] = (...args) => {
    if (shouldCloseOnSelect) closeModal();
    if (onClick) {
      onClick(...args);
    }
  };

  return (
    <HoverableElement isTriggerElementClickable={!props.disabled} tooltipText={tooltipText}>
      <DropdownAction
        {...props}
        checkboxProps={checkboxProps}
        radioButtonProps={radioButtonProps}
        isDisplayed={isTriggered}
        onClick={handleClick}
      />
    </HoverableElement>
  );
};

// Cast `ActionBase` as `any` so that Typescript doesn't go crazy when receiving
// props that don't belong to `ActionBase` in conjunction with the `as` prop
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Action = styled(ActionBase as any)<ActionProps>`
  display: flex;

  ${({ danger }) =>
    danger &&
    css`
      color: ${COLOR.danger} !important;
    `}
`;
